import { normalize, schema } from 'normalizr';
import { IIncompleteMemberFromMatch, IMember } from '../../../members/types';
import { IPicture } from '../../../pictures/types';
import { interactionSchema } from '../../models/interactions/interaction.schema';
import { IApiInteractionResult } from '../../models/interactions/interaction.types';
import { createMemberSchema } from '../../models/member/member.schema';
import { IApiPagination } from '../../models/pagination/pagination.types';
import { pictureSchema } from '../../models/picture';
import { mainScoreSchema } from '../../models/score/score.schema';
import { memberSerializer } from '../helper';

const interactionsSchema = new schema.Object({
  data: [interactionSchema],
  included: new schema.Array(
    {
      member: createMemberSchema(memberSerializer),
      picture: pictureSchema,
      score: mainScoreSchema,
    },
    'type'
  ),
});

export interface IInteractionsNormalizer {
  isSub?: boolean;
  entities: {
    memberInteractionInfo: Record<string, IIncompleteMemberFromMatch>;
    members: Record<string, IMember>;
    pictures: Record<string, IPicture>;
    scores: Record<
      string,
      {
        score: number;
      }
    >;
  };
  result: {
    data: string[];
    included: Array<{ id: string; schema: string }>;
    meta: {
      pagination: IApiPagination;
    };
  };
}

export const interactionsNormalizer = (
  interaction: IApiInteractionResult
): IInteractionsNormalizer => normalize(interaction, interactionsSchema);
